/**
 * Product filters more-less
 */

var show_more_toggle = function(e) {
  var target = e.currentTarget.parentNode;
  var less = e.currentTarget.parentNode.querySelector('.product-filtering__show-more .show-less');
  var more = e.currentTarget.parentNode.querySelector('.product-filtering__show-more .show-more');
  target.classList.toggle("show");
  less.classList.toggle("show");
  more.classList.toggle("show");
};

var show_more_init = function() {
  var show_more = document.querySelector('.product-filtering__show-more .show-more');
  var show_less = document.querySelector('.product-filtering__show-more .show-less');

  if(show_more){
    show_more.addEventListener('click', show_more_toggle, false);
    show_less.addEventListener('click', show_more_toggle, false);
  }
};

show_more_init();


var show_categories_toggle = function(e) {
  var target = e.currentTarget.parentNode.querySelector('.woocommerce-categories');
  var plus = e.currentTarget.querySelector('.icon-plus');
  var minus = e.currentTarget.querySelector('.icon-minus');

  plus.classList.toggle("show");
  minus.classList.toggle("show");
  target.classList.toggle("show");
};

var show_categories = function() {
  var show_more = document.querySelector('.js-show-product-categories');
  var icon = document.querySelector('.js-show-product-categories .icon-plus');

  if(icon) {
    icon.classList.toggle('show');
  }

  if(show_more){
    show_more.addEventListener('click', show_categories_toggle, false);
  }
};

show_categories();
